export default __webpack_public_path__ + "static/media/peopleperhour.73d52ad5.svg";